<template>
    <div class="LoadingFull open">
        <div class="logo-image-container">
            <div class="logo first"></div>
            <div class="logo second"></div>
            <div class="logo third"></div>
            <div class="logo fourth"></div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "LoadingFull"
    }
</script>

<style scoped lang="scss">


</style>
